import { useState, useEffect } from 'react'
import { api } from 'helpers'
import { GradeLevel } from '../../../types'

/**
 * Resposta da API /api/group_school_terms/grade_groups
 * Retorna grupos de grades com ciclos e school_term_id
 */
interface GradeGroupApiResponse {
  label: string
  value: string
  cycles: string[]
  school_term_id: string | null
}

interface UseGradesReturn {
  grades: GradeLevel[]
  loading: boolean
  error: string | null
}

/**
 * Hook para buscar grade groups da API /api/group_school_terms/grade_groups
 * Retorna os grupos de grades disponíveis com seus ciclos
 */
export const useGrades = (): UseGradesReturn => {
  const [grades, setGrades] = useState<GradeLevel[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        setLoading(true)
        const response = await api.get<GradeGroupApiResponse[]>('/api/group_school_terms/grade_groups')

        const mappedGrades: GradeLevel[] = response.data.map(grade => ({
          value: grade.value,
          label: grade.label,
          cycles: grade.cycles,
          // Handle both snake_case and camelCase (in case of axios transformation)
          schoolTermId: (grade as any).school_term_id || (grade as any).schoolTermId,
        }))

        setGrades(mappedGrades)
        setError(null)
      } catch (err) {
        console.error('[useGrades] Error loading grades:', err)
        setError('Failed to load grades')
      } finally {
        setLoading(false)
      }
    }

    fetchGrades()
  }, [])

  return { grades, loading, error }
}
